import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IconModule, MediaModule, PromotionsModule, SpinnerModule } from '@spartacus/storefront'
import { RouterModule } from '@angular/router'
import { CmsConfig, provideConfig, UrlModule } from '@spartacus/core'
import { MbCartDetailsComponent } from './mb-cart-details.component'
import { MbCartItemListComponent } from '../mb-cart-item-list/mb-cart-item-list.component'
import { MbCartItemComponent } from '../mb-cart-item/mb-cart-item.component'
import { QuantityCounterModule } from '../../../shared/components/quantity-counter/quantity-counter.module'
import { SafeHtmlModule } from '../../../cms/pipes/sanitize-html/safe-html.module'
import { MbI18nModule } from '../../../translations/mb-i18n.module'
import { MbAddToCartModule } from '../mb-add-to-cart/mb-add-to-cart.module'
import { FeaturedProductsModule } from '../../../shared/components/featured-products/featured-products.module'
import { FeaturedProductsComponent } from '../../../shared/components/featured-products/featured-products.component'

@NgModule({
  declarations: [
    MbCartDetailsComponent,
    MbCartItemListComponent,
    MbCartItemComponent
  ],
  imports: [
    CommonModule,
    IconModule,
    RouterModule,
    SpinnerModule,
    PromotionsModule,
    MbI18nModule,
    UrlModule,
    MediaModule,
    QuantityCounterModule,
    SafeHtmlModule,
    MbAddToCartModule,
    FeaturedProductsModule
  ],
  exports: [
    MbCartDetailsComponent,
    MbCartItemListComponent,
    MbCartItemComponent
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        MiltenyiCartProductListComponent: {
          component: MbCartDetailsComponent
        },
        MiltenyiTeaserProductComponent: {
          component: FeaturedProductsComponent
        }
      }
    } as CmsConfig)
  ]
})
export class MbCartDetailsModule { }
